import base from "../baseurl";
import token from "../getTk";

const showAll = async (id) => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });

  const show = await api
    .post("company-form-questions/delete", {
      json: { id },
    })
    .json();
  return show;
};

export default showAll;
